import { createContext } from 'react'

import type { Meta } from '../../generated/frontend'
import type { ToastContext } from '../reviews/product-listing/ReviewsTemplateContext'

export const ArticleTemplateContext = createContext<{
  meta: Meta
  articleFreeAccountStatus?: string | null
  savedStatus?: {
    isSaved: boolean
    id: string | null | undefined
  }
  setSavedStatus?: React.Dispatch<
    React.SetStateAction<{ isSaved: boolean; id: string | null | undefined }>
  >
  toast?: ToastContext
  setToast?: React.Dispatch<React.SetStateAction<ToastContext>>
}>({
  meta: {
    canonical: '',
    contentId: '',
    dataLayer: '',
    desc: '',
    facebookDesc: '',
    facebookImage: '',
    facebookTitle: '',
    fbAppId: '',
    headCodeBlock: '',
    keywords: [],
    pageType: '',
    publishedDate: '',
    taxonomyHierarchy: {
      category: '',
      subVertical: '',
      superCategory: '',
      vertical: '',
    },
    title: '',
    twitterDesc: '',
    twitterImage: '',
    twitterTitle: '',
    updatedDateTime: Infinity,
    publishedDateTime: Infinity,
    systemContentPublishedDate: '',
    systemContentUpdatedDate: '',
    glideCurationDate: '',
    frequencyOfUpdate: '',
    reviewSchema: '',
    significantUpdate: '',
  },
  articleFreeAccountStatus: null,
  savedStatus: {
    isSaved: false,
    id: null,
  },
  setSavedStatus: () => {}, // Default no-op function
  toast: {
    displayToast: false,
    error: false,
    mainText: '',
    linkText: '',
    linkUrl: '',
    onClick: () => {},
  },
  setToast: () => {}, // Default no-op function
})
